import { loadFloorModel, loadWallModel, changeImageScreen, changeVideoScreen } from "./room1.js";
import { GetUserModel } from "../apis/getUserModel";
import { defaultModelData } from "./defaltModelData.js";
import { LoadFiles } from "../apis/loadFiles.js";
//import { userCardList } from "./getUserModel";


const body = document.querySelector("body");
const modal = document.querySelector(".modal");
const libraryModal = document.querySelector(".library-modal");
const libraryModalButton = document.querySelector(".library-modal");
const fpModal = document.querySelector(".fp-modal");
const UploadModal = document.querySelector(".upload-modal");
const fileModal = document.querySelector(".files-modal");
const fileUploadModal = document.querySelector(".upload-file-modal")
let currentpoint;
let currentOpenLibrary;

export const openModal = () => {
  modal.classList.add("is-open");
  body.style.overflow = "hidden";
};

export const openLibraryModal = (place, point) => {
  console.log(place)
  currentpoint = point;
  //userCardList('floor')
  userCardList(place)
  cardlist(defaultModelData, place);
  libraryModal.classList.add("is-open");
  body.style.overflow = "hidden";
};

export const openFPModal = () => {
  fpModal.classList.add("is-open");
  body.style.overflow = "hidden";
}

export const openUploadModal = () => {
  closeLibraryModal();
  UploadModal.classList.add("is-open");
  body.style.overflow = "hidden";
}

export const openFileModal = () => {
  console.log("openFileModal")
  fileList()
  fileModal.classList.add("is-open");
  body.style.overflow = "hidden";
}

export const openFileUploadModal = () => {
  closeFilesModal();
  fileUploadModal.classList.add("is-open");
  body.style.overflow = "hidden";
}

export const closeModal = () => {
  modal.classList.remove("is-open");
  libraryModalButton.style.display = 'flex'
  body.style.overflow = "initial";
};

export const closeLibraryModal = () => {
  //libraryModalButton.style.display = 'none';
  libraryModal.classList.remove("is-open");
  document.getElementById('card-container').innerHTML = '';
  document.getElementById('user-card-container').innerHTML = '';
  body.style.overflow = "initial";
};

export const closeFPModal = () => {
  //libraryModalButton.style.display = 'none';
  fpModal.classList.remove("is-open");
  body.style.overflow = "initial";
};

export const closeUploadModal = () => {
  //libraryModalButton.style.display = 'none';
  document.getElementById("model-name").value = '';
  document.getElementById("place").value = 'mesh_7';
  document.querySelector(".model").value = '';
  document.querySelector(".model-images").value = '';
  UploadModal.classList.remove("is-open");
  body.style.overflow = "initial";
};

export const closeFilesModal = () => {
  //libraryModalButton.style.display = 'none';
  fileModal.classList.remove("is-open");
  document.getElementById('files-image-card-container').innerHTML = '';
  document.getElementById('files-video-card-container').innerHTML = '';
  body.style.overflow = "initial";
};

export const closeFileUploadModal = () => {
  document.querySelector(".image-file").value ='';
  //libraryModalButton.style.display = 'none';
  fileUploadModal.classList.remove("is-open");
  body.style.overflow = "initial";
};

var cardlist = function (defaultModelData, place) {
  currentOpenLibrary = place;
  defaultModelData.map((item) => {
    if (item.placeName === place) {
      const list = document.getElementById('card-container').innerHTML += '<li class="cards_item" id="' + item.modelId + '"><div class="card"><div class="card_image"><img src="' + item.modelImage + '"></div><div><h2 class="card_title">' + item.modelName + '</h2></div></div></li>';
    }
  })

  const list = document.getElementById('card-container')
  var li = list.getElementsByTagName("li");

  for (var i = 0; i < li.length; i++) {
    li[i].addEventListener("click", LoadDefaultModel);
  }
}

var userCardList = async function (place) {
  var data = await GetUserModel()
  let userModels 
  if(data){
    userModels = data.result
  }

  if(userModels!=null){
    userModels.map((item) => {
      if (item.placeLocation === place) {
        const list = document.getElementById('user-card-container').innerHTML += '<li class="cards_item" id="' + item.modelId + '"><div class="card"><div class="card_image"><img src="' + item.modelImageUrl + '"></div><div><h2 class="card_title">' + item.modelName + '</h2></div></div></li>';
      }
    })
    const list = document.getElementById('user-card-container')
    var li = list.getElementsByTagName("li");
    for (var i = 0; i < li.length; i++) {
      li[i].addEventListener("click", LoadUserModel);
    }
  }
}

var fileList = async function (place) {
  var data = await LoadFiles()
  //console.log(data.result.data)
  let files = [
    {
      fileName: "d995f5a2-7d03-46b2-89c3-9de37919ceb2_20220308T12244145536.png",
      fileUrl: "https://aurainteract.com/library/agwxr/2d/nft_1.jpg"
    },
    {
      fileName: "d995f5a2-7d03-46b2-89c3-9de37919ceb2_20220308T12244145537.png",
      fileUrl: "https://aurainteract.com/library/agwxr/2d/nft_2.jpg"
    },
    {
      fileName: "d995f5a2-7d03-46b2-89c3-9de37919ceb2_20220308T12244145538.png",
      fileUrl: "https://aurainteract.com/library/agwxr/2d/nft_3.jpg"
    },
    {
      fileName: "1.mp4",
      fileUrl: "https://aurainteract.com/library/agwxr/2d/1.mp4"
    },
    {
      fileName: "2.mp4",
      fileUrl: "https://aurainteract.com/library/agwxr/2d/2.mp4"
    },
    {
      fileName: "3.mp4",
      fileUrl: "https://aurainteract.com/library/agwxr/2d/3.mp4"
    },
  ]
  // if(data){
  //   files = data.result.data
  // }

  console.log(files)
  if(files!=null){
    files.map((item) => {
      if(item.fileName.split(".")[1] == 'jpg' || item.fileName.split(".")[1] == 'png'){ 
        console.log(item)
        const list = document.getElementById('files-image-card-container').innerHTML += '<li class="cards_item" id="' + item.fileUrl + '"><div class="card"><div class="card_image"><img src="' + item.fileUrl + '"></div></div></li>';
      }
    })
    const list = document.getElementById('files-image-card-container')
    var li = list.getElementsByTagName("li");
    for (var i = 0; i < li.length; i++) {
      li[i].addEventListener("click", imageChange);
    }

    files.map((item) => {
      if(item.fileName.split(".")[1] == 'mp4' || item.fileName.split(".")[1] == 'MP4'){
        console.log(item)
        const list = document.getElementById('files-video-card-container').innerHTML += '<li class="cards_item" id="' + item.fileUrl + '"><div class="card"><div class="card_image"><img src="' + item.fileUrl + '"></div></div></li>';
      }
    })
    const vlist = document.getElementById('files-video-card-container')
    var li = vlist.getElementsByTagName("li");
    for (var i = 0; i < li.length; i++) {
      li[i].addEventListener("click", videoChange);
    }
  }
}

function imageChange(e) {
  console.log(e)
  closeFilesModal();
  changeImageScreen(e.srcElement.parentNode.parentNode.parentNode.id);
}

function videoChange(e) {
  console.log(e)
  closeFilesModal();
  changeVideoScreen(e.srcElement.parentNode.parentNode.parentNode.id);
}

function LoadDefaultModel(e) {
  closeLibraryModal();
  if(currentOpenLibrary == 'mesh_7'){
    console.log(e.srcElement.parentNode.parentNode.parentNode.id)
    loadFloorModel(e.srcElement.parentNode.parentNode.parentNode.id, currentpoint, false);
  }
  else
    loadWallModel(e.srcElement.parentNode.parentNode.parentNode.id, currentpoint, false)
}

function LoadUserModel(e) {
  closeLibraryModal();
  if(currentOpenLibrary == 'mesh_7')
    loadFloorModel(e.srcElement.parentNode.parentNode.parentNode.id, currentpoint, true);
  else
    loadWallModel(e.srcElement.parentNode.parentNode.parentNode.id, currentpoint, true)
  //loadFloorModel(e.srcElement.parentNode.parentNode.id, currentpoint, true);
}

